import axios from 'axios';

export const GET_ITEM_COUNTING_DASHBOARD_DATA =
  'GET_ITEM_COUNTING_DASHBOARD_DATA';

export function getItemCountingDashboardData(payload) {
  return {
    type: GET_ITEM_COUNTING_DASHBOARD_DATA,
    payload,
  };
}
